/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };
  
  var formatTierPrice = function formatTierPrice(value) {
    return algolia.formatMoney(Number(value));
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = '<b>' + formatPrice(price) + '</b>';
    if (comparing) {
      res +=
        ' <span class="ais-hit--price-striked"><span>' +
        formatPrice(compare_at_price) +
        '</span></span> ';
      res +=
        ' <span class="ais-hit--price-discount" style="font-weight: ' +
        Math.floor(discount_ratio * 10) * 100 +
        ';">-' +
        Math.floor(discount_ratio * 100) +
        '%</span>';
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
objectQuantity: function objectQuantity() {
	return '<div class="o-quantity-selector o-product-thumbnail__add-quantity" data-quantity-selector data-min="1" data-max="'+this.inventory_quantity+'">'+
  '<div class="o-quantity-selector__inner"><button type="button" class="o-quantity-selector__button is-minus" data-quantity-selector-minus>'+
      '<svg class="o-quantity-selector__icon" viewBox="0 0 11.16 1.8" xmlns="http://www.w3.org/2000/svg"><path d="m10.25 1.8h-9.35a.9.9 0 0 1 0-1.8h9.35a.9.9 0 0 1 .91.9.9.9 0 0 1 -.91.9z"/></svg>'+
    '</button><div class="o-quantity-selector__input"><input data-index="" type="text" value="1" name="qty" class="o-quantity-selector__input-field o-input" data-quantity-selector-field /></div>'+
    '<button type="button" class="o-quantity-selector__button is-plus" data-quantity-selector-plus>'+
      '<svg class="o-quantity-selector__icon" height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg"><g fill="#000"><path d="m11 .2c-.6 0-1 .4-1 1v9h-9c-.6 0-1 .4-1 1s.4 1 1 1h9v9c0 .6.4 1 1 1s1-.4 1-1v-9h9c.6 0 1-.4 1-1s-.4-1-1-1h-9v-9c0-.6-.4-1-1-1z" fill="#000" /></g></svg>'+
    '</button></div></div>';
},
updateTotalPriceHandled: function updateTotalPriceHandled(inputElement, basePrice, pricingTiers, change, maxQuantity) {
  var currentQuantity = Number(inputElement.value);
  var newQuantity = currentQuantity + change;
  // var maxQuantity = Number(this.inventory_quantity);

  if (newQuantity < 1 || currentQuantity == maxQuantity) {
    return;
  }

  var total = basePrice;

  if (pricingTiers) {
    var smallVolumeMax = pricingTiers.small_volume_max || Infinity;
    var mediumVolumeMax = pricingTiers.medium_volume_max || Infinity;
    var mediumVolumePrice = pricingTiers.medium_volume_price || basePrice;
    var largeVolumePrice = pricingTiers.large_volume_price || basePrice;

    if (newQuantity <= smallVolumeMax) {
      total = basePrice;
    } else if (newQuantity > smallVolumeMax && newQuantity <= mediumVolumeMax) {
      total = mediumVolumePrice / 100;
    } else if (newQuantity > mediumVolumeMax) {
      total = largeVolumePrice / 100;
    }
  }

  var totalPriceElement = inputElement.closest('.ais-hit--cart').querySelector('.total-price');
  if (totalPriceElement) {
    totalPriceElement.textContent = 'Total Price: $' + (total * newQuantity).toFixed(2);
  } else {
    console.error('Total price element not found for input', inputElement);
  }
},
productObjectQuantity: function productObjectQuantity() {
    const pricingString = this.meta && this.meta.pricing ? JSON.stringify(this.meta.pricing).replace(/"/g, '&quot;') : '{}';
    
    return '<div class="o-quantity-selector o-product-thumbnail__add-quantity" data-quantity-selector data-min="1" data-max="' + this.inventory_quantity + '" style="display: flex; align-items: center; position: relative;">' +
    '<div class="o-product-quantity-selector__inner" style="display: flex; width: 100%; align-items: center; position: relative;">' +
      '<button type="button" class="o-quantity-selector__button is-minus" data-quantity-selector-minus onclick="updateTotalPriceHandled(this.nextElementSibling.children[0], ' + this.price + ', ' + pricingString + ', -1)" style="flex: none;">' +
        '<svg class="o-quantity-selector__icon" viewBox="0 0 11.16 1.8" xmlns="http://www.w3.org/2000/svg"><path d="m10.25 1.8h-9.35a.9.9 0 0 1 0-1.8h9.35a.9.9 0 0 1 .91.9.9.9 0 0 1 -.91.9z"/></svg>' +
      '</button>' +
      '<div class="o-quantity-selector__input" style="flex-grow: 1; margin: 0 10px;">' +
        '<input type="number" class="quantity-input o-quantity-selector__input-field o-input o-quantity-selector-collection" value="1" name="qty" placeholder="Type qty" ' +
      'oninput="updateTotalPrice(this, ' + this.price + ', ' + pricingString + ')" ' +
      'onblur="updateTotalPrice(this, ' + this.price + ', ' + pricingString + ')" ' +
      'onmount="updateTotalPrice(this, ' + this.price + ', ' + pricingString + ')" ' +
      (this.min !== 'null' ? 'min="' + this.min + '"' : '') + 
      (this.max !== 'null' ? 'max="' + this.max + '"' : '') +
      ' data-quantity-selector-field>' +
      '</div>' +
    '<button type="button" class="o-quantity-selector__button is-plus" data-quantity-selector-plus onclick="updateTotalPriceHandled(this.previousElementSibling.children[0], ' + this.price + ', ' + pricingString + ', 1, ' + this.inventory_quantity + ')">' +
      '<svg class="o-quantity-selector__icon" height="22" viewBox="0 0 22 22" width="22" xmlns="http://www.w3.org/2000/svg"><g fill="#000"><path d="m11 .2c-.6 0-1 .4-1 1v9h-9c-.6 0-1 .4-1 1s.4 1 1 1h9v9c0 .6.4 1 1 1s1-.4 1-1v-9h9c.6 0 1-.4 1-1s-.4-1-1-1h-9v-9c0-.6-.4-1-1-1z" fill="#000" /></g></svg>'+
    '</button></div></div>';
},
initialTotalPrice: function initialTotalPrice() {
  if (this.inventory_quantity == 0) return;
  return `<p class="total-price">Total Price: $${this.price.toFixed(2)}</p>`
},
updateTotalPrice: function updateTotalPrice(inputElement, basePrice, pricingTiers) {
  var quantity = Number(inputElement.value);
  var total = basePrice;

  if (pricingTiers) {
    var smallVolumeMax = pricingTiers.small_volume_max || Infinity;
    var mediumVolumeMax = pricingTiers.medium_volume_max || Infinity;
    var mediumVolumePrice = pricingTiers.medium_volume_price || basePrice;
    var largeVolumePrice = pricingTiers.large_volume_price || basePrice;

    if (quantity <= smallVolumeMax) {
      total = basePrice;
    } else if (quantity > smallVolumeMax && quantity <= mediumVolumeMax) {
      total = mediumVolumePrice / 100;
    } else if (quantity > mediumVolumeMax) {
      total = largeVolumePrice / 100;
    }
  }

  var totalPriceElement = inputElement.closest('.ais-hit--cart').querySelector('.total-price');
  if (totalPriceElement) {
    totalPriceElement.textContent = 'Total Price: $' + (total * quantity).toFixed(2);
  } else {
    console.error('Total price element not found for input', inputElement);
  }
},
updateTotalPriceFromData: function updateTotalPriceFromData(inputElement) {
  var basePrice = parseFloat(inputElement.dataset.basePrice);
  var smallVolumeMax = parseInt(inputElement.dataset.smallVolumeMax);
  var mediumVolumePrice = parseFloat(inputElement.dataset.mediumVolumePrice);
  var mediumVolumeMax = parseInt(inputElement.dataset.mediumVolumeMax);
  var largeVolumePrice = parseFloat(inputElement.dataset.largeVolumePrice);
  var quantity = parseInt(inputElement.value);
  var total;

  if (quantity <= smallVolumeMax) {
    total = basePrice;
  } else if (quantity > smallVolumeMax && quantity <= mediumVolumeMax) {
    total = mediumVolumePrice;
  } else if (quantity > mediumVolumeMax) {
    total = largeVolumePrice;
  }

  var totalPriceElement = inputElement.closest('.ais-hit--cart').querySelector('.total-price');
  totalPriceElement.textContent = 'Total Price: $' + (total * quantity).toFixed(2);
},
tagPrint: function tagPrint() {
  if(this.compare_at_price > this.price) return '<span class="o-product-thumbnail__sale">SALE</span>';
  else 
    if (this.tags.includes('Best_Seller')) return '<span class="o-product-thumbnail__bestseller">Best Seller</span>';
  },
    productSchema: function productSchema() {
      if(this.inventory_available) var stock = 'InStock';
      else var stock = 'OutOfStock';
    return '<script type="application/ld+json" data-product-json>{'+
  '"@context": "http://schema.org/",'+
  '"@type": "Product",'+
  '"name": "'+this.title+'",'+
  '"description": "'+escapeHtml(this.body_html_safe)+'",'+
  '"sku": "'+this.sku+'",'+
  '"brand": {"@type": "Thing","name": "'+this.vendor+'"},'+
      '"image": ["'+this.image+'"],'+
      '"offers": [{"@type": "Offer",'+
  '"availability": "http://schema.org/'+stock+'",'+
  '"price":"'+this.price+'",'+
  '"priceCurrency": "'+Currency.currency+'",'+
  '"url": "'+shopDomain+'/products/'+this.handle+'",'+
      '"sku": "'+this.sku+'"}]'+
    '}</script>';
 
  },
    okendo: function okendo() {
        var okendo = null;
        if (this.meta !== undefined && this.meta.okendo !== undefined) {
            if (this.meta.okendo.ProductListingSnippet !== undefined) {
                okendo = '<div data-oke-reviews-product-listing-rating>' + this.meta.okendo.ProductListingSnippet + '</div>';
            }
        }
        return okendo;
    },
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    pullForce: function pullForce() {
      if (this.meta.details)
      {
        var str = this.meta.details.detail_value;
        var label = JSON.parse(this.meta.details.detail_label);
        console.log(label[0]);
      	str = str.replace(/^"(.*)"$/, '$1');
        var filteredStr = JSON.parse(str);
        if(filteredStr[0] && label[0].includes('Pull Force'))
        return '<br><span class="algolia-pull-force" data-pull-force>Pull Force: '+filteredStr[0]+'<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#515f75" class="o-popup__pull-force-info bi bi-info-circle-fill" viewBox="0 0 16 16">  <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/></svg></span>';
      }
    },
    tierPrice: function tierPrice() {
      if (this.meta.pricing) {
        var smallVolume = Number(this.meta.pricing.small_volume_max);
        var mediumVolume = Number(this.meta.pricing.medium_volume_max);
        var largePrice = this.meta.pricing.large_volume_price ? Number(this.meta.pricing.large_volume_price) : '';
        var mediumPrice = this.meta.pricing.medium_volume_price ? Number(this.meta.pricing.medium_volume_price) : '';
        var base_price = Number(this.price) * 100;
        var tierPrice = '<div class="o-product-pricing tier-price-block " data-tier-price="1">';
        tierPrice += '<div class="o-product-pricing__tier-collection">'
      tierPrice += '<span class="o-product-pricing__money-small">'+formatPrice(this.price)+'</span>';
        if(smallVolume > 0)
	  tierPrice += '<span class="o-product-pricing__volume o-paragraph"> for 1 to '+ smallVolume + ' items</span>';
	  tierPrice += '</div>';
        if(mediumPrice) {
		tierPrice += '<div class="o-product-pricing__tier-collection">';
        tierPrice += '<span class="o-product-pricing__money-small">'+formatTierPrice(mediumPrice)+'</span>';
          if(mediumVolume > 0)
		tierPrice += '<span class="o-product-pricing__volume o-paragraph"> buy '+(smallVolume+1)+ ' to '+ mediumVolume + ' items</span>';
          else
		tierPrice += '<span class="o-product-pricing__volume o-paragraph"> buy '+(smallVolume+1)+ '+ items</span>';
            
          if(mediumPrice < base_price) {
		tierPrice += '<span class="o-paragraph"> and</span>';
          tierPrice += '<span class="o-product-pricing__save o-paragraph is-bold"> save '+Math.round(((base_price-mediumPrice)/base_price)*100)+'%</span>';
          }
		  tierPrice += '</div>';
        }
        if(largePrice) {
		tierPrice += '<div class="o-product-pricing__tier-collection">';
        tierPrice += '<span class="o-product-pricing__money-small">'+formatTierPrice(largePrice)+'</span>';
		tierPrice += '<span class="o-product-pricing__volume o-paragraph"> buy '+(mediumVolume+1)+ '+ items</span>';
          if(largePrice < base_price) {
		tierPrice += '<span class="o-paragraph"> and</span>';
          tierPrice += '<span class="o-product-pricing__save o-paragraph is-bold"> save '+Math.round(((base_price-largePrice)/base_price)*100)+'%</span>';
          }
		  tierPrice += '</div>';
        }
        tierPrice += '</div>';
          return tierPrice;
        
      }
      //10/05/2024
      //else return '<div class="o-product-pricing tier-price-block " data-tier-price="0"><span class="o-product-pricing__money-small">'+formatPrice(this.price)+'</span></div>';
      else {
        if(this.compare_at_price ==0){ 
          return '<div class="o-product-pricing tier-price-block " data-tier-price="0"><span class="o-product-pricing__money-small">'+formatPrice(this.price)+'</span></div>';
        }
        else{
          return '<div class="o-product-pricing tier-price-block " data-tier-price="0"><span class="o-product-pricing__money-small"><div class="price__sale "> <span> <s class="price-item--regular">' +formatPrice(this.compare_at_price)+ '</s> </span><span class="price-item--sale"> '+formatPrice(this.price)+'</span><span class="price-item--save"> SAVE '+formatPrice(this.compare_at_price - this.price)+'</span> </div></span> </div>';
        }
      }
    },
    tierThumbPrice: function tierThumbPrice() {
      if (this.meta.pricing) {
        //var smallVolume = this.meta.pricing.small_volume_max;
        //var mediumVolume = this.meta.pricing.medium_volume_max;
        var largePrice = this.meta.pricing.large_volume_price ? this.meta.pricing.large_volume_price : '';
        var mediumPrice = this.meta.pricing.medium_volume_price ? this.meta.pricing.medium_volume_price : '';
        var base_price = Number(this.price) * 100;
        
      if(largePrice && Number(largePrice) < base_price)
        var thumbTierPrice = formatTierPrice(largePrice) + ' - ' + formatPrice(this.price)
      else if(mediumPrice && Number(mediumPrice) < base_price)
        var thumbTierPrice = formatTierPrice(mediumPrice) + ' - ' + formatPrice(this.price)
      else
        var thumbTierPrice = formatPrice(this.price)
      
          return thumbTierPrice;
        
      }
      else return formatPrice(this.price);
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = this._highlightResult.title.value;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = algolia.helpers.fullEscapedAttribute(
        this._highlightResult.title.value
      );
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      return algolia.helpers.fullEscapedAttribute(
        this._highlightResult.product_type.value
      );
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      return algolia.helpers.fullEscapedAttribute(
        this._highlightResult.vendor.value
      );
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  window.updateTotalPrice = algolia.helpers.updateTotalPrice;
  window.updateTotalPriceHandled = algolia.helpers.updateTotalPriceHandled;
  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
